import useOrganizationName from '@/hooks/useOrganizationName';
import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetOrganizationServices = () => {
  const organizationName = useOrganizationName();

  return useQuery({
    queryKey: ['services', 'division', 'type', 'range', organizationName],
    queryFn: () =>
      api.services.getServices({
        filter:
          // Filtrar por divisiones de grupo o divisiones de rango
          'filter.or.serviceDivisionGroups.active=boolean.eq.true&filter.or.serviceDivisions.type=string.like.range'
      })
  });
};

export default useGetOrganizationServices;
